export default __webpack_public_path__ + "static/media/us-states.aee0d624.jpeg";